import { render, staticRenderFns } from "./ModalBlockLogin.vue?vue&type=template&id=013c2d6a&scoped=true&"
import script from "./ModalBlockLogin.vue?vue&type=script&lang=ts&"
export * from "./ModalBlockLogin.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBlockLogin.vue?vue&type=style&index=0&id=013c2d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c2d6a",
  null
  
)

export default component.exports